import React from 'react';
import PropTypes from 'prop-types';

class ImageComponent extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      image,
      imageRef,
      style,
    } = this.props;


    return (

      <img onLoad={this.handleImageLoaded} ref={imageRef} src={image} alt="text" style={style} />

    );
  }
}

export default ImageComponent;


ImageComponent.defaultProps = {
  image: '',
  style: {},
  imageRef: () => {},
};

ImageComponent.propTypes = {
  image: PropTypes.string,
  style: PropTypes.object,
  imageRef: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/text-to-image/components/image-component/ImageComponent.jsx